import React, { useState } from "react";
import { useTable, usePagination, useRowSelect } from "react-table";
import StaticTextField from "../../../../components/StaticTextField";
import activo_icono from "../../../../assets/vw/svg/point-verde.svg";
import inactivo_icono from "../../../../assets/vw/svg/point-rojo.svg";
import double_before from "../../../../assets/vw/svg/double-before.svg";
import before from "../../../../assets/vw/svg/before.svg";
import after from "../../../../assets/vw/svg/after.svg";
import double_after from "../../../../assets/vw/svg/double-after.svg";
import DropDown from "../../../../components/Dropdown";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import editar_icon from "../../../../assets/vw/svg/editar_blanco.svg";
import archivar_blanco from "../../../../assets/vw/svg/archivar_blanco.svg";
import menu_opc from "../../../../assets/vw/svg/menu-opciones.svg";
import success_icono from "../../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../../assets/vw/svg/cerrar.svg";
import Loading from "../../../../components/Loading";
import DropdownSearch from "../../../../components/DropdownSearch";
import InputText from "../../../../components/InputText";
import null_icono from "../../../../assets/vw/svg/null.svg";
import Cards from "../Cards";


const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;
    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          type="checkbox"
          className="checkbox-round"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function Table({
  columns,
  data,
  aplicaciones,
  roles,
  servicio,
  marca,
  nombreMarca,
  handleChange,
}) {
  const [modal, setModal] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [app, setApp] = useState("");
  const [usuario, setUsuario] = useState("");
  const [rol, setRol] = useState("");
  const [agregar, setAgregar] = useState(false);
  const [activo, setActivo] = useState(true);
  const [fechaCreacion, setFechaCreacion] = useState("");
  const [fechaActualizacion, setFechaActualizacion] = useState("");
  const [limit, setLimit] = useState(10);
  const limitMostrar = ["Mostrar 15", "Mostrar 30", "Mostrar 50", "Todo"];
  const [searchInput, setSearchInput] = useState("");
  const [row, setRow] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeArchivar, setMensajeArchivar] = useState(
    "¿Seguro que quieres archivar este usuario?"
  );
  const [successArchivar, setSuccessArchivar] = useState(false);
  const [errorArchivar, setErrorArchivar] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [selectGrid, setSelectGrid] = useState([]);
  const [edita, setEdita] = useState(false);
  const [idUserApp, setIdUserApp] = useState(0);
  const [selectedUser, setSelectedUser] = useState();

  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }

  const optionLimit = (textoLimit) => {
    switch (textoLimit) {
      case "Mostrar 15":
        return 15;
      case "Mostrar 30":
        return 30;
      case "Mostrar 50":
        return 50;
      case "Todo":
        return data.length;
      default:
        return data.length;
    }
  };

  function nuevo() {
    setEdita(false);
    setModal(true);
    setActivo(true);
    setUsuario("");
    setRol("");
    setFechaCreacion("");
    setFechaActualizacion("");
    setAgregar(true);
    setApp("");
    setIdUserApp(0);
  }

  function cancelar() {
    setModal(false);
    setUsuario("");
    setRol("");
    setApp("");
  }

  function localDateTimeToUTC(date) {
    const fechaLocal = new Date(date);

    // Fecha UTC en formato compatible con MYSQL: YYYY-MM-DD HH:MM:SS
    const fechaUTC = fechaLocal.toISOString().slice(0, 19).replace("T", " ");

    return fechaUTC;
  }

  function editar(e) {
    setEdita(true);
    setModal(true);
    setApp(e.row.original.app);
    setActivo(e.row.original.activo === 1 ? true : false);
    setUsuario(e.row.original.usuario);
    setRol(e.row.original.nombreRol);
    setFechaCreacion(localDateTimeToUTC(e.row.original.fechaCreacion));
    setFechaActualizacion(localDateTimeToUTC(e.row.original.fechaModificacion));
    setIdUserApp(e.row.original.idusuarioxaplicacion);
  }

  async function envia() {
    setCargando(true);
    setModal(false);
    const aplicacion = Number(app);
    try {
      let res = await fetch(
        process.env.REACT_APP_URL_DTO_BACK + "usuarioxaplicacion",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + servicio.getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            usuario,
            rol,
            aplicacion,
            activo,
            terminosCondiciones: false,
          }),
        }
      );
      console.log(res);
      const responseBody = await res.json();
      setCargando(false);
      setMostrarModal(true);
      if (res.ok) {
        setMensajeArchivar("Los cambios fueron guardados.");
        setErrorArchivar(false);
        setSuccessArchivar(true);
        setMostrarModal(true);
        setUsuario("");
        setRol("");
        setApp("");
      } else {
        setMensajeArchivar(
          "Hubo un error al guardar los cambios. " + responseBody.mensaje
        );
        setCargando(false);
        setErrorArchivar(true);
        setMostrarModal(true);
        setUsuario("");
        setRol("");
        setApp("");
        setSuccessArchivar(false);
      }
    } catch (error) {
      console.log(error);
      setMensajeArchivar("Hubo un error al guardar los cambios. " + error.message);
      setCargando(false);
      setErrorArchivar(true);
      setMostrarModal(true);
      setUsuario("");
      setRol("");
      setApp("");
      setSuccessArchivar(false);
    }
  }

  function handleCheckBoxActivo({ target }) {
    if (activo || activo === 1) setActivo(false);
    else setActivo(true);
  }

  function activaDesactiva() {
    setCargando(true);
    setMostrarModal(false);
    let arrayUsuarios = [];
    if (row !== "") {
      arrayUsuarios.push(row);
    } else if (selectedFlatRows.length > 0) {
      arrayUsuarios = selectedFlatRows.map((row) => row.original);
    } else if (selectGrid.length > 0) {
      arrayUsuarios = selectGrid;
    }

    const promises = arrayUsuarios.map(usuario => 
      fetch(process.env.REACT_APP_URL_DTO_BACK + "usuarioxaplicacion", {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: usuario.idusuarioxaplicacion,
        }),
      })
      .then(async (res) => {
        let responseBody = await res.json();
        if (!res.ok) {
          throw new Error(responseBody.mensaje);
        }
        return responseBody.mensaje;
      })
    );

    Promise.all(promises)
      .then((results) => {
        console.log("Usuarios archivados correctamente:", results);
        setRow("");
        setCargando(false);
        setMensajeArchivar("Los cambios fueron guardados.");
        setSuccessArchivar(true);
        setMostrarModal(true);
      })
      .catch((error) => {
        console.error("Error al archivar usuarios:", error);
        setRow("");
        setCargando(false);
        setMensajeArchivar("Hubo un error al guardar los cambios.");
        setErrorArchivar(true);
        setMostrarModal(true);
      });
  }

  function handleArchivar(e) {
    selectedFlatRows.length < 1 && selectGrid.length < 1
      ? setRow(e.row.original)
      : setRow("");
    setMostrarModal(true);
  }

  function clearModalArchivar() {
    if (successArchivar || errorArchivar) {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } else {
      setRow("");
      setMostrarModal(false);
      setMensajeArchivar("¿Seguro que quieres archivar este usuario ");
      setSuccessArchivar(false);
      setErrorArchivar(false);
    }
  }

  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearModalArchivar}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>
              {buildContent()}
              {successArchivar || errorArchivar ? "" : buildButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildContent = () => {
    return (
      <>
        {successArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : errorArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        ) : (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <label className="popup_title d-flex justify-content-center">
              {mensajeArchivar}
            </label>
          </div>
        )}
      </>
    );
  };

  const buildButtons = () => {
    return (
      <div className="d-flex justify-content-center gap-3 mt-3 mt-sm-4 mt-lg-5 mb-3 mb-lg-5">
        <button
          type="button"
          className="button_vw button_vw--secondary"
          data-bs-dismiss="modal"
          onClick={clearModalArchivar}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="button_vw button_vw--primary"
          data-bs-dismiss="modal"
          onClick={activaDesactiva}
        >
          Archivar
        </button>
      </div>
    );
  };

  const disable_guardar = () => {
    if (app === "" || rol === "" || usuario === "") {
      return true;
    } else {
      return false;
    }
  };

  const buildPopUpRegistro = () => {
    return (
      modal && (<div
        className={`modal fade modal_vw  ${modal ? "show" : ""}`}
        id="modal"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={modal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal_lg_vw"
          role="document"
        >
          <div className="modal-content modal_content-vw p-0 p-lg-2">
            <div className="modal-header modal_header-vw ">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal(false);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className="modal-body mx-3 mx-sm-4 mx-lg-5 p-0 mb-2 mb-sm-4 mb-lg-0 position-static">
              <div className="modal-title-container d-flex justify-content-start titulo pb-2 pb-sm-3">
                <span className={"modal-title-principal-text"}>{edita ? "Editar usuario" : "Nuevo usuario"}</span>
                {
                  edita && (
                    <button
                      type="button"
                      className={"button_vw button_vw--archivo modal-btn-archivar-top mb-lg-2"}
                      onClick={() => {
                        if (selectedUser) {
                          handleArchivar(selectedUser);
                        }
                      }}
                    >
                      <div className={"archivar-icon"}></div>
                      <span className={"ml-2"}>Archivar</span>
                    </button>
                    )
                }
              </div>
              <div className=" border_vw"></div>
              <div className="row mt-4 p-0 mx-0">
                <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                  <DropdownSearch
                    menu={aplicaciones}
                    title={"Aplicación"}
                    defaultValue={app}
                    handleOptionSelected={(e) => {
                      setApp(parseInt(e.props.value));
                    }}
                    fieldID={'idApp'}
                    fieldToShow={'nombre'}
                    disabled={idUserApp !== 0 ? true : false}
                  />
                </div>

                <div className="col-12 col-sm-6 px-0 pl-0 pl-sm-2 pt-3 pt-sm-0 mt-2 mt-sm-0">
                  <DropdownSearch
                    menu={roles}
                    title={"Rol"}
                    defaultValue={rol}
                    handleOptionSelected={(e) => {
                      setRol(e.props.value);
                    }}
                    fieldID={'nombre'}
                    fieldToShow={'nombre'}
                  />
                </div>
              </div>

              <div className="row p-0 mx-0 mt-4">
                <div className="col-12 col-sm-6 ps-0 pr-0 pr-sm-2">
                  <InputText
                    inputLabel={"Usuario"}
                    inputField={usuario}
                    id="usuario"
                    changingInput={(event) => {
                      setUsuario(event.target.value);
                    }}
                    disabled={idUserApp !== 0 ? true : false}
                  />
                </div>

                <div className="col-12 col-sm-6 col-lg-3 ps-0 pr-0 pr-lg-2 mt-2 mt-sm-0 pl-0 pl-sm-2">
                  <StaticTextField 
                    value={fechaCreacion}
                    inputLabel={"Fecha de creación"}
                    type="date"
                  />
                </div>
                <div className="col-12 col-sm-6 col-lg-3 pe-0 pl-0 pl-lg-2 mt-2 mt-lg-0 pr-sm-2 pr-lg-0">
                  <StaticTextField 
                    value={fechaActualizacion}
                    inputLabel={"Fecha de actualización"}
                    type="date"
                  />
                </div>
              </div>

              <div className="d-flex flex-row gap-2 mt-3">
                <input
                  type="checkbox"
                  className="checkbox-round mt-1"
                  id="activo"
                  defaultChecked={activo}
                  disabled={agregar}
                  onChange={handleCheckBoxActivo}
                />
                <label htmlFor="contar" className="text-general-vw">
                  Activo
                </label>
              </div>
            </div>
            <div className="modal-footer footer_modal_vw d-flex justify-content-center justify-content-lg-end gap-2 gap-sm-3 gap-lg-2 px-0 mx-3 mx-lg-5 mb-2 mb-lg-0">
              <button
                type="button"
                className="button_vw button_vw--secondary order-2 order-sm-1"
                data-bs-dismiss="modal"
                onClick={cancelar}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="button_vw button_vw--primary order-1 order-sm-2"
                data-bs-dismiss="modal"
                onClick={() => envia()}
                disabled={disable_guardar()}
                data-track-click="btn-guardar-uxa"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>)
    );
  };

  const onChangeGrid = (value) => {
    setShowGrid(value);
    setSelectGrid([]);
    toggleAllRowsSelected(false);
  };
  const selects = (checkObj, tipo) => {
    if (tipo === "push") {
      setSelectGrid([...selectGrid, checkObj]);
    } else if (tipo === "pop") {
      let idusuarioxaplicacion = checkObj.idusuarioxaplicacion;
      setSelectGrid((l) =>
        l.filter((item) => item.idusuarioxaplicacion !== idusuarioxaplicacion)
      );
    }
  };

  const gridUserApp = (page) => {
    const selectCheck = (e, index) => {
      let y = document.getElementById(e.target.id);
      let destinatario = page[index].original;
      if (y.checked) {
        selects(destinatario, "push");
      } else {
        selects(destinatario, "pop");
      }
    };

    const getApp = (idApp) => {
      const objApp = aplicaciones.find((app) => app.idApp === idApp);
      return objApp.nombre;
    };

    return (
      <div className="grid__view row">
        {page.map((tiposObj, index) => {
          return (
            <div className="col-3 mb-3" key={index}>
              <div className="card_grid">
                <div className="d-flex">
                  <div className="container_id">
                    {tiposObj.original.idusuarioxaplicacion}
                  </div>
                  <div key={"select-" + index} className="ms-auto">
                    <input
                      key={"select-" + index}
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"select-" + index}
                      value={tiposObj.original.idusuarioxaplicacion}
                      onChange={(e) => selectCheck(e, index)}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-start flex-column mx-4 mt-3 size-card">
                  <div
                    className="onclick w-100"
                    onClick={() => {
                      setSelectedUser({row: tiposObj});
                      editar({row: tiposObj});
                    }}
                  >
                    <div className="title_card">
                    {tiposObj.original.nombreRol.length > 20
                        ? `${tiposObj.original.nombreRol.substring(0, 18)}…`
                        :tiposObj.original.nombreRol}
                    </div>
                    <div className="url_description mb-auto pt-2">
                    {tiposObj.original.usuario.length > 28
                        ? `${tiposObj.original.usuario.substring(0, 25)}…`
                        :tiposObj.original.usuario}
                    </div>
                    <div className="url_card mt-1">App:</div>
                    <div className="url_description mb-auto pt-1">
                      {getApp(tiposObj.original.app)}
                    </div>
                  </div>
                  <div>
                    <img src={activo_icono} alt="activo"></img>
                    <div className={` tooltip_vw`}>
                      <img src={menu_opc} alt="menu"></img>
                      <div className="tooltiptext p-2 ">
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => {
                            setSelectedUser({row: tiposObj});
                            editar({row: tiposObj});
                          }}
                          data-track-click="btn-editar-uxa"
                        >
                          <div className="aling-icon">
                            {" "}
                            <img
                              src={editar_icon}
                              alt="editar"
                              className="px-1"
                            ></img>{" "}
                            Editar
                          </div>
                        </button>
                        <button
                          className="button_icon-vw"
                          type="button"
                          onClick={() => handleArchivar({ row: tiposObj })}
                        >
                          <div className="aling-icon-archivar">
                            {" "}
                            <img
                              src={archivar_blanco}
                              alt="archivar"
                              className="px-2"
                            ></img>{" "}
                            Archivar
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    selectedFlatRows,
    setPageSize,
    state: { pageIndex },
    toggleAllRowsSelected,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 15 },
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const NavigationControl = () => {
    return (
        <div className="btn-group btn-group-controls" role="group" aria-label="First group">
          <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_before} alt="first"/>
          </button>
          {" "}
          <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={before} alt="before"/>
          </button>
          {" "}
          <div className="num_pagination py-3">
            {pageIndex + 1} de {pageOptions.length}
          </div>
          <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={after} alt="after"/>
          </button>
          {" "}
          <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className={
                "btn btn-secondary btn__secondary-- btn_pagination"
              }
          >
            <img src={double_after} alt="last"/>
          </button>
          {" "}
        </div>
    );
  }

  return cargando ? (
      <Loading/>
  ) : (
      <>
        <div className="content main-content-container">
          <div className="main-content-actions row m-0 py-2">
            <div className="col-7 col-sm-6 col-lg-3 wrapper m-0 p-0 ">
              <input
                  className="input_vw"
                  name="searchInput"
                  value={searchInput || ""}
                  onChange={(e) => {
                    searchText(e);
                  }}
                  placeholder="Busca por ID, nombre, número…."
              />
              <span className="pt-2 ps-1">
              <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
            </span>
            </div>

            <div className="d-flex col-1 col-sm-1 col-lg-3">
              <button
                  type="button"
                  onClick={nuevo}
                  className={"button_vw button_vw--primary button_new_item " + (!!(selectedFlatRows.length > 0 || selectGrid.length > 0) ? "is_not_enabled" : "enabled")}
                  disabled={!!(selectedFlatRows.length > 0 || selectGrid.length > 0)}
                  data-track-click="btn-nuevo-uxa"
              >
                <div className={"add-icon"}></div>
                <span className={"ml-2"}>Nuevo</span>
              </button>

              {selectedFlatRows.length > 0 || selectGrid.length > 0 ? (
                  <button
                      type="button"
                      className={"button_vw button_vw--archivo button_store_item"}
                      onClick={handleArchivar}
                  >
                    <div className={"archivar-icon"}></div>
                    <span className={"ml-2"}>Archivar</span>
                  </button>
              ) : (
                  ""
              )}
            </div>

            <div className="col-3 col-sm-5 col-lg-6 p-0">
              <div className="d-flex justify-content-end align-items-center">
                <div className={`view_select_all ${showGrid ? 'icon_grid_active' : ''} ms-auto align-self-center`}>
                  <input
                      type="checkbox"
                      className="checkbox-round mx-1"
                      id={"1"}
                      value={0}
                      onChange={() => {
                      }}
                  />
                </div>
                <div className="view__options">
                  <button
                      className="button_icon-vw kit_icon"
                      type="button"
                      onClick={() => onChangeGrid(true)}
                  >
                  <span
                      className={`${showGrid ? "icon-grid-active" : "icon-grid"}`}
                  >
                    {" "}
                  </span>
                  </button>
                  <button
                      className="button_icon-vw kit_icon"
                      type="button"
                      onClick={() => onChangeGrid(false)}
                  >
                  <span
                      className={`${
                          !showGrid ? "icon-table-active" : "icon-table"
                      }`}
                  >
                    {" "}
                  </span>
                  </button>
                </div>
                <div className="">
                  <DropDown
                      menu={limitMostrar}
                      title={limitMostrar[0]}
                      inputField={limit}
                      handleOptionSelected={(e) => {
                        const limitInt = optionLimit(e);
                        setLimit(limitInt);
                        setPageSize(Number(limitInt));
                      }}
                  />
                </div>
                <NavigationControl/>
              </div>
            </div>
          </div>
        </div>

        <Cards
            page={page}
            editar={(seleccionada) => {
              setSelectedUser(seleccionada);
              editar(seleccionada);
            }}
            handleArchivar={handleArchivar}
            selects={selects}
            NavigationControl={NavigationControl}
            aplicaciones={aplicaciones}
        />

        {showGrid ? (
            gridUserApp(page)
        ) : (
          <div 
          className="table-responsive"
          style={{
            overflowY: 'hidden'
          }}
        >
            <table
                {...getTableProps()}
          className="table table-striped table-responsive tabla_contenido_vw"
        >
          <thead className="thead-dark">
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="thead__titulo"
              >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="tbody-table">
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="table-tr-check">
                  {row.cells.map((cell, cellId) => {
                    if (cell.column.id !== "selection" && (cell.value === undefined || cell.value === "") ) {
                      return (
                        <td key={cellId}><img src={null_icono} alt="sinsoporte"></img></td>
                      );
                    }
                    if (cell.column.id === "selection") {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    }
                    if (cell.column.Header === "Activo") {
                      if (cell.value === 1) {
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                          >
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={activo_icono} alt="activo"></img>
                              </div>
                              <div className={`tooltip_vw`}>
                                <img src={menu_opc} alt="menu"></img>
                                <div className="tooltiptext p-2 ">
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => {
                                      setSelectedUser(cell);
                                      editar(cell)
                                    }}
                                    data-track-click="btn-editar-uxa"
                                  >
                                    <div className="aling-icon">
                                      {" "}
                                      <img
                                        src={editar_icon}
                                        alt="editar"
                                        className="px-1"
                                      ></img>{" "}
                                      Editar
                                    </div>
                                  </button>
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar(cell)}
                                  >
                                    <div className="aling-icon-archivar">
                                      {" "}
                                      <img
                                        src={archivar_blanco}
                                        alt="archivar"
                                        className="px-2"
                                      ></img>{" "}
                                      Archivar
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        );
                      } else
                        return (
                          <td
                            className="contenido_boolean"
                            {...cell.getCellProps()}
                          >
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={inactivo_icono} alt="inactivo"></img>
                              </div>
                              <div className={` tooltip_vw`}>
                                <img src={menu_opc} alt="menu"></img>
                                <div className="tooltiptext p-2 ">
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => {
                                      setSelectedUser(cell);
                                      editar(cell);
                                    }}
                                    data-track-click="btn-editar-uxa"
                                  >
                                    <div className="aling-icon">
                                      {" "}
                                      <img
                                        src={editar_icon}
                                        alt="editar"
                                        className="px-1"
                                      ></img>{" "}
                                      Editar
                                    </div>
                                  </button>
                                  <button
                                    className="button_icon-vw"
                                    type="button"
                                    onClick={() => handleArchivar(cell)}
                                  >
                                    <div className="aling-icon-archivar">
                                      {" "}
                                      <img
                                        src={archivar_blanco}
                                        alt="archivar"
                                        className="px-2"
                                      ></img>{" "}
                                      Archivar
                                    </div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        );
                    }
                    return (
                      <td
                        className="contenido_boolean"
                        {...cell.getCellProps()}
                        onClick={() => {
                          setSelectedUser(cell);
                          editar(cell);
                        }}
                      >
                        {cell.render("Cell")}{" "}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      )}

      {buildPopUp()}
      {buildPopUpRegistro()}
    </>
  );
}

function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "idusuarioxaplicacion",
      },
      {
        Header: "Usuario",
        accessor: "usuario",
      },
      {
        Header: "Rol",
        accessor: "nombreRol",
      },
      {
        Header: "Aplicacion",
        accessor: "app",
        Cell: (p) => (
          <div>
            {" "}
            {
              props.aplicaciones.filter((x) => x.idApp === p.value)[0].nombre
            }{" "}
          </div>
        ),
      },
      {
        Header: "Activo",
        accessor: "activo",
      },
    ],
    [props.aplicaciones]
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.data}
        aplicaciones={props.aplicaciones}
        roles={props.roles}
        servicio={props.servicio}
        marca={props.marca}
        nombreMarca={props.marcaNombre}
        handleChange={props.handleChange}
      />
    </>
  );
}

export default Tabla;
